import { Dispatch } from "redux";
import {
    setServiceAssertionPerformanceSearchResults,
    setServiceAssertionPerformanceSearchResultsLoading
} from "@redux/actions/service-assertion-performance-actions";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { SERVER_DATE_TIME_FORMAT } from "@constants/date-formats";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import format from "date-fns/format";
import { getServiceAssertionPerformanceRequest } from "@requests/reports/get-service-assertion-performance";
import { formatServiceAssertionPerformances } from "@formatters/service-assertion-performances/service-assertion-performance-formatter";
import { ApAssertion, Assertion, ServiceOffering } from "@idw-types/data/reference-data/generic";

export const getServiceAssertionPerformancesReduxRequest = (dispatch: Dispatch) => async (
    rpServiceId: string,
    version: string,
    policyDecisions: Array<string>,
    serviceOfferingIds: Array<string>,
    startDate: Date,
    endDate: Date,
    apAssertions: Array<ApAssertion>,
    assertions: Array<Assertion>,
    serviceOfferings: Array<ServiceOffering>
) => {
    dispatch(setServiceAssertionPerformanceSearchResultsLoading(true));
    const { data, error, queryParameters } = await getServiceAssertionPerformanceRequest(
        rpServiceId,
        version,
        policyDecisions,
        serviceOfferingIds,
        format(startOfDay(startDate), SERVER_DATE_TIME_FORMAT),
        format(endOfDay(endDate), SERVER_DATE_TIME_FORMAT),
        Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    if (data?.serviceAssertionPerformances) {
        const formattedServiceAssertionPerformances = formatServiceAssertionPerformances(
            data.serviceAssertionPerformances,
            apAssertions,
            assertions,
            serviceOfferings
        );
        dispatch(setServiceAssertionPerformanceSearchResults(formattedServiceAssertionPerformances));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getServiceAssertionPerformance.error.title,
                resources.requests.getServiceAssertionPerformance.error.message,
                null,
                queryParameters
            );
        }
        dispatch(setServiceAssertionPerformanceSearchResultsLoading(false));
    }
};